import {SETTINGS_PROPS_TYPES} from '@/const';
import {ATTRIBUTES_BY_ID} from '@/store/getterTypes';
import {getBuilderKey, getBuilderTitle} from '@/ui_builder/componentsMapper';

const componentLine = (builder) => ({
  line: {
    type: SETTINGS_PROPS_TYPES.STATIC,
    value: builder.line,
  },
});
export default {
  'date': {
    component: {
      pathKey: 'DateFilter',
      props: (dynamic, builder) => ({
        ...componentLine(builder),
        key: getBuilderKey(builder),
        ['update:date']: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'onBindingPropUpdate',
          args: ['date_start'],
        },
      }),
    },
  },
  'search': {
    component: {
      pathKey: 'SearchField',
      props: (dynamic, builder) => ({
        ...componentLine(builder),
        key: getBuilderKey(builder),
        search: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'onSearch',
        },
        class: {
          type: SETTINGS_PROPS_TYPES.STATIC,
          value: ['position-relative'],
        },
      }),
    },
  },
  'event_categories': {
    component: {
      pathKey: 'CategoryFilter',
      props: (dynamic, builder) => ({
        ...componentLine(builder),
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        ['update:category']: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'onFilterUpdate',
          args: ['selectedCategory'],
        },
        interface: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'updateInterface',
          args: ['categoryFilterInterface'],
        },
      }),
    },
  },
  'participant_groups': {
    component: {
      pathKey: 'TeamGroupFilter',
      props: (dynamic, builder) => ({
        ...componentLine(builder),
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        ['update:group']: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'onFilterUpdate',
          args: ['selectedGroup'],
        },
        interface: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'updateInterface',
          args: ['groupFilterInterface'],
        },
      }),
    },
  },
  'participants': {
    component: {
      pathKey: 'TeamFilter',
      props: (dynamic, builder) => ({
        ...componentLine(builder),
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        ['update:participant']: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'onFilterUpdate',
          args: ['selectedTeam'],
        },
        interface: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'updateInterface',
          args: ['participantFilterInterface'],
        },
      }),
    },
  },
  'locations': {
    component: {
      pathKey: 'LocationFilter',
      props: (dynamic, builder) => ({
        ...componentLine(builder),
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        ['update:location']: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'onFilterUpdate',
          args: ['selectedLocation'],
        },
        interface: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'updateInterface',
          args: ['locationFilterInterface'],
        },
      }),
    },
  },
  'attributes': {
    component: {
      pathKey: 'AttributeFilter',
      props: (dynamic, builder) => ({
        ...componentLine(builder),
        key: getBuilderKey(builder),
        title: getBuilderTitle(builder),
        attributeAlias: {
          type: SETTINGS_PROPS_TYPES.STORAGE,
          callback: (store) => {
            if (!store || !store.getters) return '';
            return store.getters[ATTRIBUTES_BY_ID][builder.value]?.alias?.toLowerCase?.();
          },
        },
        ['update:attribute']: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'onAttributeUpdate',
          args: [builder.value],
        },
        interface: {
          type: SETTINGS_PROPS_TYPES.ACTION,
          method: 'updateInterface',
          args: [`attributeFilterInterface_${builder.value}`],
        },
      }),
    },
  },
};
